import { Component, EventEmitter, Input, OnInit, Output, ChangeDetectionStrategy } from '@angular/core';
import { getDescendantOrSelfIds } from 'src/app/_helpers/org-tree-helper';
import { Lookup } from 'src/app/models/lookup.model';
import { OrganizationLevel } from 'src/app/models/organizationLevel.model';
import { OrganizationLevelShareService } from 'src/app/shared/services/organization-level-share.service';
import { trackById } from 'src/app/shared/utils/track-by.util';

@Component({
  standalone: false,
  selector: 'app-template-share-control',
  templateUrl: './template-share-control.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrls: ['./template-share-control.component.scss']
})
export class TemplateShareControlComponent implements OnInit {
  @Input() isShared: boolean = false;
  @Input() organizationLevelId: string | null = null;
  @Input() dataOrganizationLevelId: string | null = null;
  @Input() canManage: boolean = true;
  @Output() shareChange = new EventEmitter<{ isShared: boolean; organizationLevelId: string | null }>();

  organizationLevels: Lookup[] = [];
  isLoading: boolean = false;

  readonly trackById = trackById;

  constructor(private orgLevelShareService: OrganizationLevelShareService) {}

  ngOnInit(): void {
    this.isLoading = true;
    this.orgLevelShareService.loadOrganizationLevels().subscribe({
      next: (data) => {
        this.organizationLevels = this.filterToDataSubtree(data.flat, data.hierarchical);
        this.isLoading = false;
      },
      error: () => {
        this.isLoading = false;
      }
    });
  }

  private filterToDataSubtree(levels: Lookup[], hierarchical: OrganizationLevel[]): Lookup[] {
    if (this.dataOrganizationLevelId == null) { return levels; }

    const allowedIds = getDescendantOrSelfIds(hierarchical, this.dataOrganizationLevelId);
    return levels.filter(level => typeof level.id === 'string' && allowedIds.has(level.id));
  }

  onShareToggle(checked: boolean): void {
    const result = this.orgLevelShareService.handleShareToggle(checked, this.organizationLevelId);
    if (!checked) {
      this.organizationLevelId = result.orgLevelId;
    }
    this.isShared = checked;
    this.emit();
  }

  onOrgLevelChange(orgLevelId: string | null): void {
    this.organizationLevelId = orgLevelId;
    this.emit();
  }

  private emit(): void {
    this.shareChange.emit({ isShared: this.isShared, organizationLevelId: this.organizationLevelId });
  }
}
